export async function loadChatwoot(token) {
  ;(function (d, t) {
    var BASE_URL = 'https://chat.weclever.co'
    var g = d.createElement(t),
      s = d.getElementsByTagName(t)[0]
    g.src = BASE_URL + '/packs/js/sdk.js'
    g.defer = true
    g.async = true
    s.parentNode.insertBefore(g, s)
    g.onload = function () {
      window.chatwootSDK.run({
        websiteToken: token,
        baseUrl: BASE_URL
      })
    }
  })(document, 'script')
}

export async function resetChatwoot() {
  if (!window.$chatwoot) return

  hideChatwoot()
  window.$chatwoot.reset()
}

export async function hideChatwoot() {
  if (!window.$chatwoot) return

  window.$chatwoot.toggleBubbleVisibility('hide')
}

export async function showChatwoot() {
  if (!window.$chatwoot) return

  window.$chatwoot.toggleBubbleVisibility('show')
}
